import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { wallets as WalletsApi } from "@teem/constants/api";

import { objectToFormData } from '@teem/helpers/functions';



@Injectable({
    providedIn: 'root'
})
export class WalletService {

    constructor(
        private httpClient: HttpClient
    ) { }
    
    public getBalance() {
        return this.httpClient.get(`${WalletsApi.balance}`)
    }

    public getTransactions(page: number = 1, perPage: number = 5) {
        return this.httpClient.get(`${WalletsApi.transactions}?page=${page}&limit=${perPage}`);
    }

    public topup(payload) {
        return this.httpClient.post(`${WalletsApi.topup}`, payload);
    }

    public withdraw(payload) {
        return this.httpClient.post(`${WalletsApi.withdraw}`, payload);
    }

    public getWIthdrawAmounts() {
        return this.httpClient.get(`${WalletsApi.withdrawAmounts}`)
    }

    public updateAutoRenew() {
        return this.httpClient.get(`${WalletsApi.updateAutoRenew}`)
    }

}
